import { TouchableOpacity, View } from "react-native";
import { Text } from "react-native-paper";
import { useNavigation } from "@react-navigation/native";
import { contentObject } from "../ReportPDRs/_utils";
import { Chip as ChipStyled } from "../../components/styled";
import useAmplitude from "../../hooks/useAmplitude";

const ReportPdr = () => {
  const navigation = useNavigation();
  const { trackEvent } = useAmplitude();

  const transformedArray = Object.keys(contentObject).map((key) => ({
    ...contentObject[key as keyof typeof contentObject],
    slug: key,
  }));

  const onSelectPDRType = (slug: string) => {
    navigation.navigate("ReportPDR", { slug });
    trackEvent("progress-report-pdr-start", {
      pdr_activity_category_name: slug,
    });
  };

  return (
    <View className="mx-6 md:mt-2 md:mb-8">
      {transformedArray.map((item) => (
        <TouchableOpacity onPress={() => onSelectPDRType(item.slug)} key={item.slug}>
          <View className="flex-col p-6 border border-sky rounded-lg mt-4">
            <item.icon />
            <Text className="text-large-tight font-700 text-ink-darkest mt-4">{item.title}</Text>
            <Text className="text-small-normal font-400 text-ink mt-3 mb-6">{item.description2}</Text>
            <View className="flex-row items-center justify-start">
              <ChipStyled className={`rounded-2xl bg-sky-lighter`} textStyle="my-0.5">
                <Text className="text-tiny-mormal font-400 text-ink-dark">{item.list[1]}</Text>
              </ChipStyled>
            </View>
            <Text className="italic text-ink-dark mt-2">{item.list[2]}</Text>
          </View>
        </TouchableOpacity>
      ))}
    </View>
  );
};

export default ReportPdr;
